const StatusIndicatorError = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='8' height='45' viewBox='0 0 8 45'>
    <defs>
      <clipPath id='clip-error'>
        <rect width='8' height='45' rx='2' />
      </clipPath>
      <filter id='shadow-error' x='-50%' y='-50%' width='200%' height='200%'>
        <feDropShadow dx='0' dy='0' stdDeviation='3' floodColor='#ef4444' floodOpacity='0.6' />
      </filter>
    </defs>

    <g clipPath='url(#clip-error)'>
      <rect width='8' height='45' rx='2' fill='#ef4444' filter='url(#shadow-error)' />
      <rect
        x='0.5'
        y='0.5'
        width='7'
        height='44'
        rx='1.5'
        fill='none'
        stroke='#dc2626'
        strokeWidth='1'
        vectorEffect='non-scaling-stroke'
      />
    </g>
  </svg>
)
export { StatusIndicatorError }
